import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"

interface SendOtpPayload {
	bankId: string
	corporateId: string
	fileId: string
}

interface VerifyOtpPayload {
	bankId: string
	corporateId: string
	fileId: string
	isAuthorized: boolean
	otpValue: string
}

interface ObjectResponse {
	message: string
	status: number
}
export const sendOtpToApprove = createAsyncThunk<boolean, SendOtpPayload>(
	"file/sendOtpToApprove",
	async ({ bankId, corporateId, fileId }: SendOtpPayload): Promise<boolean> => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}

			const baseUrl = `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/${bankId}/${corporateId}/${fileId}/approve/otp`

			const response: AxiosResponse<boolean> = await axios.get(baseUrl, config)
			return response.data
		} catch (error) {
			const axiosError = error as AxiosError<boolean>
			return axiosError?.response?.data ?? false
		}
	}
)

export const verifyOtpToApprove = createAsyncThunk<boolean, VerifyOtpPayload>(
	"file/sendOtpToApprove",
	async ({
		bankId,
		corporateId,
		fileId,
		otpValue,
		isAuthorized,
	}: VerifyOtpPayload): Promise<
		| { status: number; message: string }
		| any /* TODO RejectWithValue<unknown, unknown>*/
	> => {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					"Content-Type": "application/json",
				},
				withCredentials: true,
			}

			const baseUrl = `${process.env.REACT_APP_FILE_SERVICE_API_URL}/fileservice/apifile/v2/${bankId}/${corporateId}/${fileId}/approve/otp-verify/${isAuthorized}`

			const response: AxiosResponse<{ status: string }> = await axios.post(
				baseUrl,
				otpValue,
				config
			)
			return {
				message: response.data,
				status: response.status,
			}
		} catch (error) {
			const axiosError = error as AxiosError<boolean>
			return {
				message: axiosError?.response?.data,
				status: axiosError?.response?.status,
			}
		}
	}
)

//v2/{bankId}/{corporateId}/{fileId}/approve/otp-verify
